import L from 'leaflet';
import PropTypes from 'prop-types';
import {
  useEffect,
  useRef,
  useCallback,
} from 'react';

import {
  emptyFunction,
} from '../../utils';
import {
  useLeafletMap,
  useLeafletMapEvent,
} from '../leaflet';

function PxMapActions(props) {
  const {
    allReady = false,
    mapConfig,
    mapEvent = emptyFunction,
    resizeTrigger = false,
    setZoom,
    calcMapCenter,
  } = props;

  const map = useLeafletMap();
  const displayBounds = useRef([
    [mapConfig.latS, mapConfig.lngW],
    [mapConfig.latN, mapConfig.lngE]]);
  const hasFitted = useRef(false);

  //
  // Redraw map on request
  //
  useEffect(
    () => {
      if (map) {
      // console.log(`PxMap, resizeTrigger=${resizeTrigger}, invalidateSize`);
        map.invalidateSize({ pan: false });
      // debugger
      }
    },
    [map, resizeTrigger],
  );

  //
  // Propagate zoom info outside
  //
  const setDisplayBounds = useCallback(
    (newBounds) => {
      if (!hasFitted.current) return;
      displayBounds.current = newBounds;
      // console.log('mapEvent updateBounds');
      mapEvent({ event: 'updateBounds', newBounds });
    },
    [mapEvent],
  );

  //
  // Zoom around town bounds when all is ready
  //
  useEffect(
    () => {
      if (map && allReady && displayBounds.current[0][0]) {
        // A panel beside the map may have just mounted; measure before centring on the new width
        map.invalidateSize({ animate: false });
        map.fitBounds(displayBounds.current, { maxZoom: 15 });
        hasFitted.current = true;
      }
    },
    [allReady, map],
  );

  const handleZoomEnd = useCallback(
    () => {
      if (map) {
        // console.log(`zoom=${map.getZoom()} ${displayJson(map, 2)}`);
        // console.log(`zoom=${map.getZoom()}`);
        setZoom(map.getZoom());
        const newBounds = map.getBounds();
        setDisplayBounds([
          [newBounds._southWest.lat, newBounds._southWest.lng],
          [newBounds._northEast.lat, newBounds._northEast.lng],
        ]);
      }
    },
    [map, setZoom, setDisplayBounds],
  );

  useLeafletMapEvent(
    'zoomend',
    handleZoomEnd,
  );

  const handleMoveEnd = useCallback(
    () => {
      if (map) {
        // console.log(`zoom=${map.getZoom()} ${displayJson(map, 2)}`);
        const newBounds = map.getBounds();
        setDisplayBounds([
          [newBounds._southWest.lat, newBounds._southWest.lng],
          [newBounds._northEast.lat, newBounds._northEast.lng],
        ]);
      }
    },
    [map, setDisplayBounds],
  );

  useLeafletMapEvent(
    'moveend',
    handleMoveEnd,
  );

  const handleTouchStart = useCallback(
    (event) => {
      if (map) {
        mapEvent({
          event: 'log',
          txt: `mob touch event x=${
            event.touches[0].clientX} y=${event.touches[0].clientY}`,
        });
        const touchPoint = L.point(
          event.touches[0].clientX,
          event.touches[0].clientY,
        );
        const touchLatlng = map.layerPointToLatLng(touchPoint);
        mapEvent({
          event: 'clickMap',
          coordinates: {
            x: event.touches[0].clientX,
            y: event.touches[0].clientY,
          },
          position: touchLatlng,
        });
      }
    },
    [map, mapEvent],
  );

  useLeafletMapEvent(
    'touchstart',
    handleTouchStart,
  );

  const handleClick = useCallback(
    (event) => {
      const { latlng, containerPoint } = event;
      // debugger;
      // console.log(`click event latlng=${displayJson(latlng)}`);
      // console.log(`click event containerPoint=${displayJson(containerPoint)}`);
      mapEvent({
        event: 'clickMap',
        coordinates: {
          x: containerPoint.x,
          y: containerPoint.y,
        },
        position: latlng,
      });
      // debugger;
    },
    [mapEvent],
  );

  useLeafletMapEvent(
    'click',
    handleClick,
  );

  // const clickOverlay = useCallback(
  //   (event) => {
  //     // Find the map's touch overlay div position
  //     const touchDiv = document.getElementById('mapTouchOverlay');
  //     let touchRect = { left: 0, top: 0 };
  //     touchRect = touchDiv.getBoundingClientRect();
  //     const clientTop = document.documentElement.clientTop || document.body.clientTop || 0;
  //     const clientLeft = document.documentElement.clientLeft || document.body.clientLeft || 0;
  //     const scrollTop = window.pageYOffset || document.body.scrollTop;
  //     const scrollLeft = window.pageXOffset || document.body.scrollLeft;
  //     const touchDivTop = touchRect.top + scrollTop - clientTop;
  //     const touchDivLeft = touchRect.left + scrollLeft - clientLeft;

  //     mapEvent({
  //       event: 'log',
  //       txt: `mob overlay touch event x=${
  //         event.clientX} y=${event.clientY} touchDivTop=${
  //         touchDivTop} touchDivLeft=${touchDivLeft} event=${event}`,
  //     });
  //     const x = event.clientX - touchDivLeft;
  //     const y = event.clientY - touchDivTop;
  //     const touchPoint = L.point(x, y);
  //     console.log(`map=${map}`);
  //     // eslint-disable-next-line no-debugger
  //     // debugger;
  //     const touchLatlng = map.layerPointToLatLng(touchPoint);
  //     mapEvent({
  //       event: 'clickMap',
  //       coordinates: { x, y },
  //       position: touchLatlng,
  //     });
  //   },
  //   [map, mapEvent],
  // );

  // const touchOverlay = useCallback(
  //   (event) => {
  //     // Find the map's touch overlay div position
  //     const touchDiv = document.getElementById('mapTouchOverlay');
  //     let touchRect = { left: 0, top: 0 };
  //     touchRect = touchDiv.getBoundingClientRect();
  //     const clientTop = document.documentElement.clientTop || document.body.clientTop || 0;
  //     const clientLeft = document.documentElement.clientLeft || document.body.clientLeft || 0;
  //     const scrollTop = window.pageYOffset || document.body.scrollTop;
  //     const scrollLeft = window.pageXOffset || document.body.scrollLeft;
  //     const touchDivTop = touchRect.top + scrollTop - clientTop;
  //     const touchDivLeft = touchRect.left + scrollLeft - clientLeft;

  //     mapEvent({
  //       event: 'log',
  //       txt: `mob overlay touch event x=${
  //         event.touches[0].clientX} y=${event.touches[0].clientY} touchDivTop=${
  //         touchDivTop} touchDivLeft=${touchDivLeft}`,
  //     });
  //     const x = event.touches[0].clientX - touchDivLeft;
  //     const y = event.touches[0].clientY - touchDivTop;
  //     const touchPoint = L.point(x, y);
  //     console.log(`map=${map}`);
  //     // eslint-disable-next-line no-debugger
  //     // debugger;
  //     const touchLatlng = map.layerPointToLatLng(touchPoint);
  //     mapEvent({
  //       event: 'clickMap',
  //       coordinates: { x, y },
  //       position: touchLatlng,
  //     });
  //   },
  //   [map, mapEvent],
  // );

  useEffect(
    () => {
    // console.log(`calcMapCenter=${displayJson(calcMapCenter)}`);
      if (map && calcMapCenter) {
        map.invalidateSize({ animate: false });
        map.panTo(calcMapCenter);
      }
    },
    [map, calcMapCenter],
  );

  return null;
}

PxMapActions.propTypes = {
  allReady: PropTypes.bool,
  resizeTrigger: PropTypes.bool,
  mapConfig: PropTypes.shape({
    latN: PropTypes.number,
    latS: PropTypes.number,
    lngW: PropTypes.number,
    lngE: PropTypes.number,
    label: PropTypes.string,
  }).isRequired,
  mapEvent: PropTypes.func,
  setZoom: PropTypes.func.isRequired,
  calcMapCenter: PropTypes.arrayOf(
    PropTypes.number,
  ).isRequired,
};

export default PxMapActions;
